import { defineNuxtPlugin, useRuntimeConfig } from "nuxt/app";
import { RuntimeConfig } from "nuxt/schema";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export default defineNuxtPlugin(() => {
  const runtimeConfig: RuntimeConfig = useRuntimeConfig();

  // Skip AppInsights if Faro (Grafana) is enabled
  if (runtimeConfig.public.faroIngestUrl) return;

  const appInsightConnectionString = runtimeConfig.public.appInsightConnectionString?.toString();
  // Skip initialization if AppInsights URL is not configured
  if (!appInsightConnectionString) {
    console.warn('AppInsights: collector URL not configured. Skipping initialization.');
    return;
  }

  const appInsightsClient = new ApplicationInsights({ config: {
    connectionString: appInsightConnectionString,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
  }});

  appInsightsClient.loadAppInsights();

  return {
    provide: { 
      appInsightsClient,
    }
  };
});